import Vue from 'vue'
import I18n from 'vue-i18n'
// import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

Vue.use(I18n)

// Element默认不支持 6.x 的 vue-i18n，需要手动处理。
const messages = {
  // en: {
  //   message: require('assets/locales/en'),
  //   ...enLocale // 或者用 Object.assign({ message: 'hello' }, enLocale)
  // }
  zh: {
    message: require('assets/locales/zh'),
    ...zhLocale // 或者用 Object.assign({ message: '你好' }, zhLocale)
  }
}

export default new I18n({
  locale: 'zh',
  messages
})



// WEBPACK FOOTER //
// ./src/libraries/i18n/index.js